import styled from '@emotion/styled'

/* eslint-disable @stylistic/max-len */
export const InputContainer = styled.div<{ horizontalLayout?: boolean }>`
  display: flex;
  align-items: stretch;
  flex: 0 0 auto;

  & > *:first-child /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {
    flex: 1 1 auto;
  }

  & > *:not(:first-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {
    margin-left: 0.5em;
  }

  ${props =>
    props.horizontalLayout &&
    `
      flex-basis: 50%;
      max-width: 50%;
      padding-right: 5px;
      align-self: start;
  `}
`
